import { useEffect } from 'react';
import { CandidateResumeUploaderInput } from 'domain/shared/candidate';
import { useFormContext } from 'framework/form';
import { SubmitButton } from 'framework/ui/ui-builder';
import moveToInterviewFormValidationSchema from './moveToInterviewFormValidationSchema';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';

interface MoveToInterviewFormProps {
  handleCancelClick: () => void;
}

const MoveToInterviewForm = ({ handleCancelClick }: MoveToInterviewFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(moveToInterviewFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignContent="center" gap="20px">
        <CandidateResumeUploaderInput label="Candidate's CV" source="resumeId" maxElements={1} isRequired />

        <CandidateResumeUploaderInput label="Screening materials" source="screeningMaterialsId" maxElements={1} />
      </Box>

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default MoveToInterviewForm;
